// extracted by mini-css-extract-plugin
module.exports = {"container":"_1kxFKk1UfKmPn1qGO3f3x8"};